// import React, { useState, useEffect } from 'react';
// import Navbar from '../../../Components/Navbar';
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import './homecleanStyle.css';
// import HomeCleanOrderForm from './HomeCleanOrderForm';
// import PromptLoginCard from '../PromptLoginCard';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';

// import homecleanimage1 from '../images/home.png';
// import homecleanimage2 from '../images/Home-Cleaninggg.jpg';
// import homecleanimage3 from '../images/Cleaning-Service.jpg';

// const HomeClean = () => {
//     const [bedrooms, setBedrooms] = useState(1);
//     const [bathrooms, setBathrooms] = useState(0);
//     const [kitchens, setKitchens] = useState(1);
//     const [drawingdinning, setDrawingdinning] = useState(1);
//     const [cloths, setCloths] = useState(0);
//     const [dishes, setDishes] = useState(0);
//     const [showOrderForm, setShowOrderForm] = useState(false);
//     const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//     const [user, setUser] = useState(null);

//     useEffect(() => {
//         const fetchUserData = async () => {
//             try {
//                 const token = localStorage.getItem('token');
//                 if (token) {
//                     const decodedToken = jwtDecode(token);
//                     const userId = decodedToken.Id;
//                     const extractedUserId = userId.startsWith('user-') ? userId.split('user-')[1] : userId;
//                     const response = await axios.get(`${URL}/user/${extractedUserId}`, {
//                         headers: {
//                             Authorization: `Bearer ${token}`
//                         }
//                     });
//                     setUser(response.data);
//                 }
//             } catch (error) {
//                 console.error('Error fetching user data:', error);
//             }
//         };
//         fetchUserData();
//         window.scrollTo(0, 0);
//     }, []);

//     // useEffect(() => {
//     //     window.scrollTo(0, 0); // Scroll to top when component mounts
//     // }, []);

//     const sliderImages = [
//         homecleanimage1,
//         homecleanimage2,
//         homecleanimage3
//     ];

//     const settings = {
//         dots: true,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//     };

//     const generateTimeSlots = () => {
//         const startTime = 7; // Start time in 24-hour format
//         const endTime = 21; // End time in 24-hour format
//         const timeSlots = [];

//         // Time slots from start to end
//         for (let hour = startTime; hour <= endTime; hour++) {
//             for (let minute = 0; minute < 60; minute += 30) {
//                 const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
//                 const displayTime = hour === 12
//                     ? `12:${String(minute).padStart(2, '0')} PM`
//                     : hour > 12
//                         ? `${hour - 12}:${String(minute).padStart(2, '0')} PM`
//                         : `${hour}:${String(minute).padStart(2, '0')} AM`;
//                 timeSlots.push(<option key={time} value={displayTime}>{displayTime}</option>);
//             }
//         }

//         return timeSlots;
//     };

//     const calculatePrice = () => {
//         let price = 200; // Minimum charge

//         // Calculate price based on selections
//         price += (bedrooms - 1) * 30; // Each additional bedroom adds 30 tk
//         price += (kitchens - 1) * 20; // Each additional kitchen adds 20 tk
//         price += (drawingdinning - 1) * 40;
//         price += (bathrooms * 50); // Each additional bathroom adds 50 tk
//         // Calculate cloth cleaning price
//         price += Math.ceil(cloths / 5) * 30;
//         // Calculate dish cleaning price
//         price += Math.ceil(dishes / 5) * 20;

//         return price;
//     };

//     const handleGetService = (e) => {
//         e.preventDefault();
//         if (user) { // Check if user object exists
//             setShowOrderForm(true);
//         } else {
//             setShowLoginPrompt(true);
//         }
//     };

//     const formData = {
//         bedrooms,
//         bathrooms,
//         kitchens,
//         drawingdinning,
//         cloths,
//         dishes,
//         price: calculatePrice(),
//         date: document.querySelector('input[type="date"]')?.value,
//         time: document.querySelector('select[required]')?.value,
//     };

//     return (
//         <div>
//             <Navbar />
//             <div className={`home-clean-content ${showOrderForm ? 'blur' : ''}`}>
//                 {/* <h1>Home Clean</h1> */}
//                 <div className="slider-container">
//                     <Slider {...settings}>
//                         {sliderImages.map((image, index) => (
//                             <div key={index}>
//                                 <img src={image} alt={`Slide ${index + 1}`} />
//                             </div>
//                         ))}
//                     </Slider>
//                 </div>
//                 <div className="HomeClean-form-container">
//                     <div className="HomeClean-form-header">
//                         <h2>Home Cleaning</h2>
//                         <div className="reviews">
//                             <span className="stars">★★★★★</span>
//                             <span className="review-count">82,708 Reviews</span>
//                         </div>
//                         <hr />
//                     </div>

//                     <form className="cleaning-form" onSubmit={handleGetService}>
//                         <div className="form-row">
//                             <div className="homecleaner-form-group">
//                                 <label>Bedroom</label>
//                                 <select onChange={(e) => setBedrooms(parseInt(e.target.value))}>
//                                     <option value="1">1 Bedroom</option>
//                                     <option value="2">2 Bedrooms</option>
//                                     <option value="3">3 Bedrooms</option>
//                                     <option value="4">4 Bedrooms</option>
//                                     <option value="5">5 Bedrooms</option>
//                                 </select>
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Bathroom</label>
//                                 <select onChange={(e) => setBathrooms(parseInt(e.target.value))}>
//                                     <option value="0">0 Bathroom</option>
//                                     <option value="1">1 Bathroom</option>
//                                     <option value="2">2 Bathrooms</option>
//                                     <option value="3">3 Bathrooms</option>
//                                     <option value="4">4 Bathrooms</option>
//                                     <option value="5">5 Bathrooms</option>
//                                 </select>
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Kitchen</label>
//                                 <select onChange={(e) => setKitchens(parseInt(e.target.value))}>
//                                     <option value="1">1 Kitchen</option>
//                                     <option value="2">2 Kitchens</option>
//                                 </select>
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Drawing-Dinning</label>
//                                 <select onChange={(e) => setDrawingdinning(parseInt(e.target.value))}>
//                                     <option value="1">1 Drawing-Dinning</option>
//                                     <option value="2">2 Drawing-Dinnings</option>
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="form-row">
//                             <div className="homecleaner-form-group">
//                                 <label>Cloth Cleaning</label>
//                                 <select onChange={(e) => setCloths(parseInt(e.target.value))}>
//                                     <option value="0">0 Pieces</option>
//                                     <option value="5">5 Pieces</option>
//                                     <option value="10">10 Pieces</option>
//                                     <option value="20">20 Pieces</option>
//                                 </select>
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Dish Cleaning</label>
//                                 <select onChange={(e) => setDishes(parseInt(e.target.value))}>
//                                     <option value="0">0 Dishes</option>
//                                     <option value="5">5 Dishes</option>
//                                     <option value="10">10 Dishes</option>
//                                 </select>
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Price</label>
//                                 <input type="text" placeholder="Price" readOnly value={`${calculatePrice()} tk`} />
//                             </div>
//                         </div>
//                         <div className="form-row">
//                             <div className="homecleaner-form-group">
//                                 <label>Date</label>
//                                 <input type="date" required />
//                             </div>
//                             <div className="homecleaner-form-group">
//                                 <label>Time</label>
//                                 <select required>
//                                     {generateTimeSlots()}
//                                 </select>
//                             </div>
//                         </div>
//                         <button type="submit">Get The Service</button>
//                     </form>
//                 </div>
//             </div>

//             {showOrderForm && (
//                 <HomeCleanOrderForm user={user} formData={formData} onClose={() => setShowOrderForm(false)} />
//             )}
//             {showLoginPrompt && (
//                 <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//             )}
//         </div>
//     );
// };

// export default HomeClean;

// **************** All okay and perfectly worked **************** //
// import React, { useState, useEffect, useMemo  } from 'react';
// import { useLocation } from 'react-router-dom';
// import Navbar from '../../../Components/Navbar';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { FaCalendarAlt } from 'react-icons/fa';
// import HomeCleanOrderForm from './HomeCleanOrderForm';
// import PromptLoginCard from '../PromptLoginCard';
// import homecleanimage1 from '../images/home.png';
// import './homecleanStyle.css';

// const HomeClean = () => {
//   const location    = useLocation();
//   const rebookState = location.state?.fromRebook || false;       //  detect rebook flag
//   //  memoize previous order so useEffect deps are stable
//   const prevOrder   = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // State variables for form inputs and UI control
//   const [bedrooms, setBedrooms] = useState(1);
//   const [bathrooms, setBathrooms] = useState(0);
//   const [kitchens, setKitchens] = useState(1);
//   const [drawingdinning, setDrawingdinning] = useState(1);
//   const [cloths, setCloths] = useState(0);
//   const [dishes, setDishes] = useState(0);
//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState(null);

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//       const now = new Date();
//       const currentHour = now.getHours();
//       // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//       if (currentHour < 7 || currentHour >= 21) {
//         const tomorrow = new Date();
//         tomorrow.setDate(now.getDate() + 1);
//         return tomorrow;
//       }
//       return now;
//     };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setBedrooms(prevOrder.bed       || 1);
//       setBathrooms(prevOrder.bath     || 0);
//       setKitchens(prevOrder.kitchen   || 1);
//       setDrawingdinning(prevOrder.dra_din || 1);
//       setCloths(prevOrder.cloth       || 0);
//       setDishes(prevOrder.dish        || 0);
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data on component mount
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith('user-') ? decodedToken.Id.split('user-')[1] : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Generate available time slots based on selected date
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7; // 7 AM
//   //   const endTime = 21; // 9 PM
//   //   const slots = [];
//   //   const now = new Date();
//   //   const todayStr = now.toISOString().split('T')[0];
//   //   const selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   let startHour = startTime;
//   //   let startMinute = 0;

//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split('T')[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split('T')[0] : '';

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on selected options
//   const calculatePrice = () => {
//     let price = 200; // Minimum charge
//     price += (bedrooms - 1) * 30; // Each additional bedroom adds 30 tk
//     price += (kitchens - 1) * 20; // Each additional kitchen adds 20 tk
//     price += (drawingdinning - 1) * 40; // Each additional drawing-dinning adds 40 tk
//     price += bathrooms * 50; // Each bathroom adds 50 tk
//     price += Math.ceil(cloths / 5) * 30; // Cloth cleaning, 30 tk per 5 pieces
//     price += Math.ceil(dishes / 5) * 20; // Dish cleaning, 20 tk per 5 dishes
//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const time = e.target.time.value;
//     const dateStr = selectedDate.toISOString().split('T')[0];
//     const formDetails = {
//       bedrooms,
//       bathrooms,
//       kitchens,
//       drawingdinning,
//       cloths,
//       dishes,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Handle order submission from the modal
//   const handleOrderSubmit = (orderData) => {
//     console.log('Order Data:', orderData);
//     setShowOrderForm(false);
//   };

//   return (
//     <div className="HomeCleanService-container">
//       <Navbar />
//       <div className="HomeCleanService-card">
//         {/* Hero Section */}
//         <div className="HomeCleanService-hero">
//           <img src={homecleanimage1} alt="Home Cleaning Services Hero" />
//         </div>

//         {/* Header Section */}
//         <div className="HomeCleanService-header">
//           {/* <h1>Professional Home Cleaning Services</h1> */}
//           <h1>
//             {rebookState
//               ? 'Rebook Home Cleaning Service'
//               : 'Professional Home Cleaning Services'}
//           </h1>
//           <div className="HomeCleanService-rating">★★★★★</div>
//           <div className="HomeCleanService-reviews">82,708 Verified Reviews</div>
//         </div>

//         {/* Categories Section */}
//         <div className="HomeCleanService-categories">
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🛏️</span> Bedroom Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Thorough cleaning of bedrooms, including dusting and vacuuming.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🚽</span> Bathroom Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Deep cleaning of bathrooms, sanitizing all surfaces.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🍽️</span> Kitchen Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Cleaning of kitchen counters, appliances, and floors.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🧺</span> Laundry Services</h5>
//             <p className="HomeCleanService-serviceDescription">Washing and folding of clothes and linens.</p>
//           </div>
//         </div>

//         {/* Form Section */}
//         <form onSubmit={handleGetService} className="HomeCleanService-form">
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bedrooms">Bedrooms</label>
//               <select id="bedrooms" value={bedrooms} onChange={(e) => setBedrooms(parseInt(e.target.value))}>
//                 <option value="1">1 Bedroom</option>
//                 <option value="2">2 Bedrooms</option>
//                 <option value="3">3 Bedrooms</option>
//                 <option value="4">4 Bedrooms</option>
//                 <option value="5">5 Bedrooms</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bathrooms">Bathrooms</label>
//               <select id="bathrooms" value={bathrooms} onChange={(e) => setBathrooms(parseInt(e.target.value))}>
//                 <option value="0">0 Bathroom</option>
//                 <option value="1">1 Bathroom</option>
//                 <option value="2">2 Bathrooms</option>
//                 <option value="3">3 Bathrooms</option>
//                 <option value="4">4 Bathrooms</option>
//                 <option value="5">5 Bathrooms</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="kitchens">Kitchens</label>
//               <select id="kitchens" value={kitchens} onChange={(e) => setKitchens(parseInt(e.target.value))}>
//                 <option value="1">1 Kitchen</option>
//                 <option value="2">2 Kitchens</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="drawingdinning">Drawing-Dinning</label>
//               <select id="drawingdinning" value={drawingdinning} onChange={(e) => setDrawingdinning(parseInt(e.target.value))}>
//                 <option value="1">1 Drawing-Dinning</option>
//                 <option value="2">2 Drawing-Dinnings</option>
//               </select>
//             </div>
//           </div>
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="cloths">Cloth Cleaning</label>
//               <select id="cloths" value={cloths} onChange={(e) => setCloths(parseInt(e.target.value))}>
//                 <option value="0">0 Pieces</option>
//                 <option value="5">5 Pieces</option>
//                 <option value="10">10 Pieces</option>
//                 <option value="20">20 Pieces</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="dishes">Dish Cleaning</label>
//               <select id="dishes" value={dishes} onChange={(e) => setDishes(parseInt(e.target.value))}>
//                 <option value="0">0 Dishes</option>
//                 <option value="5">5 Dishes</option>
//                 <option value="10">10 Dishes</option>
//               </select>
//             </div>
//           </div>
//           <div className="HomeCleanService-priceDisplay">
//             <span>Estimated Price: {calculatePrice()} tk</span>
//           </div>
//           <div className="HomeCleanService-bookingDetails">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="date">Preferred Date</label>
//               <div className="HomeCleanService-dateInputWrapper">
//                 <DatePicker
//                   selected={selectedDate}
//                   onChange={(date) => setSelectedDate(date)}
//                   dateFormat="dd-MMM-yyyy"
//                   minDate={new Date()}
//                   placeholderText="Select a date"
//                   className="HomeCleanService-dateInput"
//                 />
//                 <FaCalendarAlt className="HomeCleanService-dateIcon"
//                     onClick={() =>
//                         document
//                         .querySelector(".react-datepicker__input-container input")
//                         .click()
//                     }
//                   />
//               </div>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="time">Preferred Time</label>
//               <select id="time" name="time" required>
//                 {generateTimeSlots(selectedDate).map((slot, idx) => (
//                   <option key={idx} value={slot}>{slot}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
//           <button type="submit" className="HomeCleanService-actionBtn">
//             {/* Book Service Now */}
//             {rebookState ? 'Confirm Rebooking' : 'Book Service Now'}
//             </button>
//         </form>

//         {/* Info Box */}
//         <div className="HomeCleanService-infoBox">
//           <h4>About Our Home Cleaning Services</h4>
//           <p>Our professional cleaners provide thorough cleaning services for your home, ensuring a spotless and healthy environment. All services come with a 30-day guarantee.</p>
//         </div>

//         {/* Additional Info Sections */}
//         <div className="HomeCleanService-additionalInfo">
//           <div className="HomeCleanService-sectionCard">
//             <h2 className="HomeCleanService-sectionTitle">How to Place an Order</h2>
//             <ol className="HomeCleanService-stepList">
//               <li>Select the areas you need cleaned (e.g., bedrooms, bathrooms).</li>
//               <li>Choose additional services like cloth or dish cleaning.</li>
//               <li>Select a preferred date and time slot.</li>
//               <li>Log in or create an account if you haven’t already.</li>
//               <li>Review your order details and submit.</li>
//               <li>Track your order in the “Order History” section for real-time updates.</li>
//             </ol>
//           </div>
//           <div className="HomeCleanService-row2col">
//             <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg2">
//               <h2 className="HomeCleanService-sectionTitle">Why Choose HelpNao for Home Cleaning</h2>
//               <p className="HomeCleanService-sectionText">HelpNao connects you with top-rated home cleaning professionals who are committed to delivering exceptional service. Here’s why you should choose us:</p>
//               <div className="HomeCleanService-featureGrid">
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-balance-scale HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Competitive pricing with no hidden fees</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-user-shield HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Background-checked and trained cleaners</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-mobile-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Easy booking through our app or website</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-headset HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>24/7 customer support for your convenience</p>
//                 </div>
//               </div>
//             </div>
//             <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg">
//               <h2 className="HomeCleanService-sectionTitle">Key Features of Our Home Cleaning Services</h2>
//               <div className="HomeCleanService-featureGrid">
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-clock HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Flexible scheduling to fit your needs</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-shield-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Eco-friendly cleaning products available</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-check-circle HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Customized cleaning plans for your home</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-shield-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>30-day service guarantee for peace of mind</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-credit-card HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Secure online payment options</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg3">
//             <h2 className="HomeCleanService-sectionTitle">Order Tracking & History</h2>
//             <div className="HomeCleanService-orderTrackIcon">
//               <i className="fas fa-file-alt" aria-hidden="true"></i>
//             </div>
//             <p className="HomeCleanService-sectionText HomeCleanService-centerText">After booking, track your cleaning service in the “Order History” section. View upcoming appointments, service details, and payment history all in one place.</p>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       {showOrderForm && (
//         <HomeCleanOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//         />
//       )}
//       {showLoginPrompt && <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />}
//     </div>
//   );
// };

// export default HomeClean;

// ******** New Update with features - All checked and Okay (19-6-25)********* //
// import React, { useState, useEffect, useMemo  } from 'react';
// import { useLocation } from 'react-router-dom';
// import Navbar from '../../../Components/Navbar';
// import axios from 'axios';
// import { jwtDecode } from 'jwt-decode';
// import { URL } from '../../../config';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { FaCalendarAlt } from 'react-icons/fa';
// import HomeCleanOrderForm from './HomeCleanOrderForm';
// import PromptLoginCard from '../PromptLoginCard';
// import homecleanimage1 from '../images/home.png';
// import './homecleanStyle.css';

// const HomeClean = () => {
//   const location    = useLocation();
//   const rebookState = location.state?.fromRebook || false;       //  detect rebook flag
//   //  memoize previous order so useEffect deps are stable
//   const prevOrder   = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // State variables for form inputs and UI control
//   const [bedrooms, setBedrooms] = useState(1);
//   const [bathrooms, setBathrooms] = useState(0);
//   const [kitchens, setKitchens] = useState(1);
//   const [drawingdinning, setDrawingdinning] = useState(1);
//   const [cloths, setCloths] = useState(0);
//   const [dishes, setDishes] = useState(0);

//   // new extras
//   const [balconies, setBalconies] = useState(0);
//   const [windowGrills, setWindowGrills] = useState(0);
//   const [furniture, setFurniture] = useState(0);

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState(null);

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//       const now = new Date();
//       const currentHour = now.getHours();
//       // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//       if (currentHour < 7 || currentHour >= 21) {
//         const tomorrow = new Date();
//         tomorrow.setDate(now.getDate() + 1);
//         return tomorrow;
//       }
//       return now;
//     };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setBedrooms(prevOrder.bed       || 1);
//       setBathrooms(prevOrder.bath     || 0);
//       setKitchens(prevOrder.kitchen   || 1);
//       setDrawingdinning(prevOrder.dra_din || 1);
//       setCloths(prevOrder.cloth       || 0);
//       setDishes(prevOrder.dish        || 0);

//       // new extras:
//       setBalconies(prevOrder.balcony             || 0);
//       setWindowGrills(prevOrder.window_grill     || 0);
//       setFurniture(prevOrder.furniture_cleaning  || 0);
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data on component mount
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith('user-') ? decodedToken.Id.split('user-')[1] : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching user data:', error);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   // Generate available time slots based on selected date
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7; // 7 AM
//   //   const endTime = 21; // 9 PM
//   //   const slots = [];
//   //   const now = new Date();
//   //   const todayStr = now.toISOString().split('T')[0];
//   //   const selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   let startHour = startTime;
//   //   let startMinute = 0;

//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split('T')[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split('T')[0] : '';

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on selected options
//   const calculatePrice = () => {
//     let price = 100; // Minimum charge
//     price += (bedrooms - 1) * 30; // Each additional bedroom adds 30 tk
//     price += (kitchens - 1) * 20; // Each additional kitchen adds 20 tk
//     price += (drawingdinning - 1) * 40; // Each additional drawing-dinning adds 40 tk
//     price += bathrooms * 50; // Each bathroom adds 50 tk

//     // price += Math.ceil(cloths / 5) * 30; // Cloth cleaning, 30 tk per 5 pieces
//     // price += Math.ceil(dishes / 5) * 20; // Dish cleaning, 20 tk per 5 dishes
//     price += cloths * 10;                  // 10 tk per cloth
//     price += dishes * 10;                  // 10 tk per dish

//     // NEW:
//     price += balconies * 30;        // Balcony cleaning
//     price += windowGrills * 40;      // Window & grill
//     price += furniture * 60;        // Furniture

//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const time = e.target.time.value;
//     const dateStr = selectedDate.toISOString().split('T')[0];
//     const formDetails = {
//       bedrooms,
//       bathrooms,
//       kitchens,
//       drawingdinning,
//       cloths,
//       dishes,
//       balconies,
//       windowGrills,
//       furniture,
//       price: calculatePrice(),
//       date: dateStr,
//       time,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Handle order submission from the modal
//   const handleOrderSubmit = (orderData) => {
//     console.log('Order Data:', orderData);
//     setShowOrderForm(false);
//   };

//   // PlusMinusInput component for numeric inputs
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity }) => {
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };

//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };

//     const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;

//    return (
//       <div className="HomeCleanService-unitInput">
//         <button
//           type="button"
//           className="HomeCleanService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="HomeCleanService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="HomeCleanService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="HomeCleanService-container">
//       <Navbar />
//       <div className="HomeCleanService-card">
//         {/* Hero Section */}
//         <div className="HomeCleanService-hero">
//           <img src={homecleanimage1} alt="Home Cleaning Services Hero" />
//         </div>

//         {/* Header Section */}
//         <div className="HomeCleanService-header">
//           {/* <h1>Professional Home Cleaning Services</h1> */}
//           <h1>
//             {rebookState
//               ? 'Rebook Home Cleaning Service'
//               : 'Professional Home Cleaning Services'}
//           </h1>
//           <div className="HomeCleanService-rating">★★★★★</div>
//           <div className="HomeCleanService-reviews">82,708 Verified Reviews</div>
//         </div>

//         {/* Categories Section */}
//         <div className="HomeCleanService-categories">
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🛏️</span> Bedroom Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Thorough cleaning of bedrooms, including dusting and vacuuming.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🚽</span> Bathroom Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Deep cleaning of bathrooms, sanitizing all surfaces.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🍽️</span> Kitchen Cleaning</h5>
//             <p className="HomeCleanService-serviceDescription">Cleaning of kitchen counters, appliances, and floors.</p>
//           </div>
//           <div className="HomeCleanService-category">
//             <h5><span className="HomeCleanService-categoryIcon">🧺</span> Laundry Services</h5>
//             <p className="HomeCleanService-serviceDescription">Washing and folding of clothes and linens.</p>
//           </div>
//         </div>

//         {/* Form Section */}
//         <form onSubmit={handleGetService} className="HomeCleanService-form">
//           {/* <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bedrooms">Bedrooms</label>
//               <select id="bedrooms" value={bedrooms} onChange={(e) => setBedrooms(parseInt(e.target.value))}>
//                 <option value="1">1 Bedroom</option>
//                 <option value="2">2 Bedrooms</option>
//                 <option value="3">3 Bedrooms</option>
//                 <option value="4">4 Bedrooms</option>
//                 <option value="5">5 Bedrooms</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bathrooms">Bathrooms</label>
//               <select id="bathrooms" value={bathrooms} onChange={(e) => setBathrooms(parseInt(e.target.value))}>
//                 <option value="0">0 Bathroom</option>
//                 <option value="1">1 Bathroom</option>
//                 <option value="2">2 Bathrooms</option>
//                 <option value="3">3 Bathrooms</option>
//                 <option value="4">4 Bathrooms</option>
//                 <option value="5">5 Bathrooms</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="kitchens">Kitchens</label>
//               <select id="kitchens" value={kitchens} onChange={(e) => setKitchens(parseInt(e.target.value))}>
//                 <option value="1">1 Kitchen</option>
//                 <option value="2">2 Kitchens</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="drawingdinning">Drawing-Dinning</label>
//               <select id="drawingdinning" value={drawingdinning} onChange={(e) => setDrawingdinning(parseInt(e.target.value))}>
//                 <option value="1">1 Drawing-Dinning</option>
//                 <option value="2">2 Drawing-Dinnings</option>
//               </select>
//             </div>
//           </div>
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="cloths">Cloth Cleaning</label>
//               <select id="cloths" value={cloths} onChange={(e) => setCloths(parseInt(e.target.value))}>
//                 <option value="0">0 Pieces</option>
//                 <option value="5">5 Pieces</option>
//                 <option value="10">10 Pieces</option>
//                 <option value="20">20 Pieces</option>
//               </select>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="dishes">Dish Cleaning</label>
//               <select id="dishes" value={dishes} onChange={(e) => setDishes(parseInt(e.target.value))}>
//                 <option value="0">0 Dishes</option>
//                 <option value="5">5 Dishes</option>
//                 <option value="10">10 Dishes</option>
//               </select>
//             </div>
//           </div> */}

//           {/* Section 1: Core Room Cleaning */}
//           <h3 className="HomeCleanService-sectionTitle">
//             <i className="fas fa-home"></i> Core Room Cleaning
//           </h3>
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bedrooms">Bedrooms</label>
//               <PlusMinusInput id="bedrooms" value={bedrooms} setValue={setBedrooms} min={1} max={5} />
//             </div>
//             {/* <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bathrooms">Bathrooms</label>
//               <PlusMinusInput id="bathrooms" value={bathrooms} setValue={setBathrooms} min={0} max={5} />
//             </div> */}
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="kitchens">Kitchens</label>
//               <PlusMinusInput id="kitchens" value={kitchens} setValue={setKitchens} min={1} max={2} />
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="drawingdinning">Drawing-Dining</label>
//               <PlusMinusInput id="drawingdinning" value={drawingdinning} setValue={setDrawingdinning} min={1} max={2} />
//             </div>
//           </div>

//           {/* Section 2: Specialized Cleaning */}
//           <h3 className="HomeCleanService-sectionTitle">
//             <i className="fas fa-spray-can"></i> Specialized Cleaning
//           </h3>
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="bathroomsExtra">Bathroom Cleaning</label>
//               <PlusMinusInput id="bathroomsExtra" value={bathrooms} setValue={setBathrooms} min={0} max={5} />
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="balconies">Balcony Cleaning</label>
//               <PlusMinusInput id="balconies" value={balconies} setValue={setBalconies} min={0} max={5} />
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="windowGrills">Window & Grill Cleaning</label>
//               <PlusMinusInput id="windowGrills" value={windowGrills} setValue={setWindowGrills} min={0} max={10} />
//             </div>
//           </div>

//           {/* Section 3: Additional Services */}
//           <h3 className="HomeCleanService-sectionTitle">
//             <i className="fas fa-broom"></i> Additional Services
//           </h3>
//           <div className="HomeCleanService-serviceOptions">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="furniture">Furniture Cleaning</label>
//               <PlusMinusInput id="furniture" value={furniture} setValue={setFurniture} min={0} max={5} />
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="cloths">Cloth Cleaning</label>
//               <PlusMinusInput id="cloths" value={cloths} setValue={setCloths} min={0} max={20} />
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="dishes">Dish Cleaning</label>
//               <PlusMinusInput id="dishes" value={dishes} setValue={setDishes} min={0} max={10} />
//             </div>
//           </div>

//           <div className="HomeCleanService-priceDisplay">
//             <span>Estimated Price: {calculatePrice()} tk</span>
//           </div>
//           <div className="HomeCleanService-bookingDetails">
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="date">Preferred Date</label>
//               <div className="HomeCleanService-dateInputWrapper">
//                 <DatePicker
//                   selected={selectedDate}
//                   onChange={(date) => setSelectedDate(date)}
//                   dateFormat="dd-MMM-yyyy"
//                   minDate={new Date()}
//                   placeholderText="Select a date"
//                   className="HomeCleanService-dateInput"
//                 />
//                 <FaCalendarAlt className="HomeCleanService-dateIcon"
//                     onClick={() =>
//                         document
//                         .querySelector(".react-datepicker__input-container input")
//                         .click()
//                     }
//                   />
//               </div>
//             </div>
//             <div className="HomeCleanService-optionGroup">
//               <label htmlFor="time">Preferred Time</label>
//               <select id="time" name="time" required>
//                 {generateTimeSlots(selectedDate).map((slot, idx) => (
//                   <option key={idx} value={slot}>{slot}</option>
//                 ))}
//               </select>
//             </div>
//           </div>
//           <button type="submit" className="HomeCleanService-actionBtn">
//             {/* Book Service Now */}
//             {rebookState ? 'Confirm Rebooking' : 'Book Service Now'}
//             </button>
//         </form>

//         {/* Info Box */}
//         <div className="HomeCleanService-infoBox">
//           <h4>About Our Home Cleaning Services</h4>
//           <p>Our professional cleaners provide thorough cleaning services for your home, ensuring a spotless and healthy environment. All services come with a 30-day guarantee.</p>
//         </div>

//         {/* Additional Info Sections */}
//         <div className="HomeCleanService-additionalInfo">
//           <div className="HomeCleanService-sectionCard">
//             <h2 className="HomeCleanService-sectionTitle">How to Place an Order</h2>
//             <ol className="HomeCleanService-stepList">
//               <li>Select the areas you need cleaned (e.g., bedrooms, bathrooms).</li>
//               <li>Choose additional services like cloth or dish cleaning.</li>
//               <li>Select a preferred date and time slot.</li>
//               <li>Log in or create an account if you haven’t already.</li>
//               <li>Review your order details and submit.</li>
//               <li>Track your order in the “Order History” section for real-time updates.</li>
//             </ol>
//           </div>
//           <div className="HomeCleanService-row2col">
//             <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg2">
//               <h2 className="HomeCleanService-sectionTitle">Why Choose HelpNao for Home Cleaning</h2>
//               <p className="HomeCleanService-sectionText">HelpNao connects you with top-rated home cleaning professionals who are committed to delivering exceptional service. Here’s why you should choose us:</p>
//               <div className="HomeCleanService-featureGrid">
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-balance-scale HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Competitive pricing with no hidden fees</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-user-shield HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Background-checked and trained cleaners</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-mobile-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Easy booking through our app or website</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-headset HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>24/7 customer support for your convenience</p>
//                 </div>
//               </div>
//             </div>
//             <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg">
//               <h2 className="HomeCleanService-sectionTitle">Key Features of Our Home Cleaning Services</h2>
//               <div className="HomeCleanService-featureGrid">
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-clock HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Flexible scheduling to fit your needs</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-shield-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Eco-friendly cleaning products available</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-check-circle HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Customized cleaning plans for your home</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-shield-alt HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>30-day service guarantee for peace of mind</p>
//                 </div>
//                 <div className="HomeCleanService-featureItem">
//                   <i className="fas fa-credit-card HomeCleanService-featureIcon" aria-hidden="true"></i>
//                   <p>Secure online payment options</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg3">
//             <h2 className="HomeCleanService-sectionTitle">Order Tracking & History</h2>
//             <div className="HomeCleanService-orderTrackIcon">
//               <i className="fas fa-file-alt" aria-hidden="true"></i>
//             </div>
//             <p className="HomeCleanService-sectionText HomeCleanService-centerText">After booking, track your cleaning service in the “Order History” section. View upcoming appointments, service details, and payment history all in one place.</p>
//           </div>
//         </div>
//       </div>

//       {/* Modals */}
//       {showOrderForm && (
//         <HomeCleanOrderForm
//           onClose={() => setShowOrderForm(false)}
//           onSubmit={handleOrderSubmit}
//           formData={formData}
//           user={user}
//         />
//       )}
//       {showLoginPrompt && <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />}
//     </div>
//   );
// };

// export default HomeClean;

// ***** Upper all code is okay And Checked (19-6-25) ***** //




// ***** New added Translate EN-BN (19-6-25) ***** //
// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../../../Components/Navbar";
// import axios from "axios";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { useTranslation } from "react-i18next";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import {
//   FaCalendarAlt,
//   FaStar,
//   FaStarHalfAlt,
//   FaRegStar,
// } from "react-icons/fa";
// import HomeCleanOrderForm from "./HomeCleanOrderForm";
// import PromptLoginCard from "../PromptLoginCard";
// import homecleanimage1 from "../images/home.png";
// import "./homecleanStyle.css";
// import Footer from "../../../Components/Footer/Footer";
// import FeedbackPage from "../../Feedback/FeedbackPage";
// import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
// import Loader from "../../../Components/LoaderSpin/Loader";

// const HomeClean = () => {
//   const { t } = useTranslation();

//   const [ratingData, setRatingData] = useState({
//     reviewCount: 0,
//     avgRating: 0,
//   });

//   const location = useLocation();
//   const rebookState = location.state?.fromRebook || false; //  detect rebook flag
//   //  memoize previous order so useEffect deps are stable
//   const prevOrder = useMemo(
//     () => location.state?.previousOrder || {},
//     [location.state?.previousOrder]
//   );

//   // State variables for form inputs and UI control
//   const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
//   const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

//   const [bedrooms, setBedrooms] = useState(1);
//   const [bathrooms, setBathrooms] = useState(0);
//   const [kitchens, setKitchens] = useState(1);
//   const [drawingdinning, setDrawingdinning] = useState(1);
//   const [cloths, setCloths] = useState(0);
//   const [dishes, setDishes] = useState(0);

//   // new extras
//   const [balconies, setBalconies] = useState(0);
//   const [windowGrills, setWindowGrills] = useState(0);
//   const [furniture, setFurniture] = useState(0);

//   const [stairsFloors, setStairsFloors] = useState(0);
//   const [carpets, setCarpets] = useState(0);

//   const [remarks, setRemarks] = useState("");

//   const [showOrderForm, setShowOrderForm] = useState(false);
//   const [showLoginPrompt, setShowLoginPrompt] = useState(false);
//   const [user, setUser] = useState(null);
//   const [formData, setFormData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // const [selectedDate, setSelectedDate] = useState(new Date());

//   const getInitialDate = () => {
//     const now = new Date();
//     const currentHour = now.getHours();
//     // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
//     if (currentHour < 7 || currentHour >= 21) {
//       const tomorrow = new Date();
//       tomorrow.setDate(now.getDate() + 1);
//       return tomorrow;
//     }
//     return now;
//   };

//   const [selectedDate, setSelectedDate] = useState(getInitialDate());

//   useEffect(() => {
//     if (rebookState) {
//       setBedrooms(prevOrder.bed || 1);
//       setBathrooms(prevOrder.bath || 0);
//       setKitchens(prevOrder.kitchen || 1);
//       setDrawingdinning(prevOrder.dra_din || 1);
//       setCloths(prevOrder.cloth || 0);
//       setDishes(prevOrder.dish || 0);

//       // new extras:
//       setBalconies(prevOrder.balcony || 0);
//       setWindowGrills(prevOrder.window_grill || 0);
//       setFurniture(prevOrder.furniture_cleaning || 0);

//       setStairsFloors(prevOrder.stairs_and_railing || 0);
//       setCarpets(prevOrder.carpet_cleaning || 0)
//     }
//   }, [rebookState, prevOrder]);

//   // Fetch user data on component mount
//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         setLoading(true);
//         const token = localStorage.getItem("token");
//         if (token) {
//           const decodedToken = jwtDecode(token);
//           const userId = decodedToken.Id.startsWith("user-")
//             ? decodedToken.Id.split("user-")[1]
//             : decodedToken.Id;
//           const response = await axios.get(`${URL}/user/${userId}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           setUser(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching user data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchUserData();
//     window.scrollTo(0, 0);
//   }, []);

//   //new added for same servitor rebook
//   useEffect(() => {
//     if (rebookState && prevOrder.servitor_id) {
//       axios
//         .get(`${URL}/servitors/${prevOrder.servitor_id}`)
//         .then((res) => {
//           const s = res.data;
//           setPrevServitorName(`${s.FirstName} ${s.LastName}`);
//         })
//         .catch(console.error);
//     }
//   }, [rebookState, prevOrder.servitor_id]);

//   // Fetch only electrician ratings once
//   // useEffect(() => {
//   //   axios
//   //     .get(`${URL}/api/ratings`)
//   //     .then(({ data }) => {
//   //       const homeClean = data["home cleaning"];
//   //       setRatingData({
//   //         reviewCount: homeClean.reviewCount,
//   //         avgRating: homeClean.avgRating,
//   //       });
//   //     })
//   //     .catch((err) => console.error("Failed to load ratings:", err));
//   // }, []);

//   useEffect(() => {
//       const loadRatings = async () => {
//         try {
//           setLoading(true);
//           const { data } = await axios.get(`${URL}/api/ratings`);
//           // handle different backend key styles
//           const homeClean = data["home cleaning"] || {};
//           setRatingData({
//             reviewCount: homeClean.reviewCount || 0,
//             avgRating: homeClean.avgRating || 0,
//           });
//         } catch (err) {
//           console.error("Failed to load ratings:", err);
//         } finally {
//           setLoading(false);
//         }
//       };
//       loadRatings();
//     }, []);

//   const renderStars = (rating) => {
//     const stars = [];
//     for (let i = 1; i <= 5; i++) {
//       if (rating >= i) {
//         stars.push(<FaStar key={i} />);
//       } else if (rating >= i - 0.5) {
//         stars.push(<FaStarHalfAlt key={i} />);
//       } else {
//         stars.push(<FaRegStar key={i} />);
//       }
//     }
//     return stars;
//   };

//   // Generate available time slots based on selected date
//   // const generateTimeSlots = (dateObj) => {
//   //   const startTime = 7; // 7 AM
//   //   const endTime = 21; // 9 PM
//   //   const slots = [];
//   //   const now = new Date();
//   //   const todayStr = now.toISOString().split('T')[0];
//   //   const selectedDateStr = dateObj.toISOString().split('T')[0];
//   //   let startHour = startTime;
//   //   let startMinute = 0;

//   //   if (selectedDateStr === todayStr) {
//   //     const currentHour = now.getHours();
//   //     const currentMinute = now.getMinutes();
//   //     if (currentHour >= startTime && currentHour < endTime) {
//   //       if (currentMinute > 0 && currentMinute <= 30) {
//   //         startHour = currentHour;
//   //         startMinute = 30;
//   //       } else if (currentMinute > 30) {
//   //         startHour = currentHour + 1;
//   //         startMinute = 0;
//   //       } else {
//   //         startHour = currentHour;
//   //         startMinute = 0;
//   //       }
//   //     } else if (currentHour >= endTime) {
//   //       return [];
//   //     }
//   //   }

//   //   for (let hour = startHour; hour <= endTime; hour++) {
//   //     const minuteStart = hour === startHour ? startMinute : 0;
//   //     for (let minute = minuteStart; minute < 60; minute += 30) {
//   //       if (selectedDateStr === todayStr) {
//   //         const slotTime = new Date();
//   //         slotTime.setHours(hour, minute, 0, 0);
//   //         if (slotTime <= now) continue;
//   //       }
//   //       const displayHour = hour > 12 ? hour - 12 : hour;
//   //       const ampm = hour >= 12 ? 'PM' : 'AM';
//   //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
//   //       slots.push(formattedTime);
//   //     }
//   //   }
//   //   return slots;
//   // };

//   const generateTimeSlots = (dateObj) => {
//     const startTime = 7;
//     const endTime = 21;
//     const slots = [];
//     const now = new Date();
//     const todayStr = now.toISOString().split("T")[0];
//     const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

//     let startHour = startTime;
//     let startMinute = 0;

//     // If the selected date is today, adjust slots based on current time
//     if (selectedDateStr === todayStr) {
//       const currentHour = now.getHours();
//       const currentMinute = now.getMinutes();
//       if (currentHour >= endTime) {
//         return []; // No slots available for today
//       }
//       if (currentHour >= startTime) {
//         // Round up to the next half-hour
//         if (currentMinute > 0 && currentMinute <= 30) {
//           startHour = currentHour;
//           startMinute = 30;
//         } else if (currentMinute > 30) {
//           startHour = currentHour + 1;
//           startMinute = 0;
//         } else {
//           startHour = currentHour;
//           startMinute = 0;
//         }
//       }
//     }

//     for (let hour = startHour; hour <= endTime; hour++) {
//       const minuteStart = hour === startHour ? startMinute : 0;
//       for (let minute = minuteStart; minute < 60; minute += 30) {
//         // Skip past slots for today
//         if (selectedDateStr === todayStr) {
//           const slotTime = new Date(now);
//           slotTime.setHours(hour, minute, 0, 0);
//           if (slotTime <= now) continue;
//         }
//         const displayHour = hour > 12 ? hour - 12 : hour;
//         const ampm = hour >= 12 ? "PM" : "AM";
//         const formattedTime = `${displayHour}:${String(minute).padStart(
//           2,
//           "0"
//         )} ${ampm}`;
//         slots.push(formattedTime);
//       }
//     }
//     return slots;
//   };

//   // Calculate price based on selected options
//   const calculatePrice = () => {
//     let price = 100; // Minimum charge
//     price += (bedrooms - 1) * 30; // Each additional bedroom adds 30 tk
//     price += (kitchens - 1) * 20; // Each additional kitchen adds 20 tk
//     price += (drawingdinning - 1) * 40; // Each additional drawing-dinning adds 40 tk
//     price += bathrooms * 50; // Each bathroom adds 50 tk

//     // price += Math.ceil(cloths / 5) * 30; // Cloth cleaning, 30 tk per 5 pieces
//     // price += Math.ceil(dishes / 5) * 20; // Dish cleaning, 20 tk per 5 dishes
//     price += cloths * 10; // 10 tk per cloth
//     price += dishes * 10; // 10 tk per dish

//     // NEW:
//     price += balconies * 30; // Balcony cleaning
//     price += windowGrills * 40; // Window & grill
//     price += furniture * 60; // Furniture

//     price += stairsFloors * 40;    // 40 tk per floor of stairs & railing
//     price += carpets * 50;         // 50 tk per carpet/rug

//     return price;
//   };

//   // Handle form submission
//   const handleGetService = (e) => {
//     e.preventDefault();
//     const time = e.target.time.value;
//     const dateStr = selectedDate.toISOString().split("T")[0];
//     const formDetails = {
//       bedrooms,
//       bathrooms,
//       kitchens,
//       drawingdinning,
//       cloths,
//       dishes,
//       balconies,
//       windowGrills,
//       furniture,

//       stairsFloors,
//       carpets,

//       remarks,

//       price: calculatePrice(),
//       date: dateStr,
//       time,

//       // new added for rebook same servitor
//       useSameServitor,
//       servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
//     };
//     setFormData(formDetails);
//     if (user) {
//       setShowOrderForm(true);
//     } else {
//       setShowLoginPrompt(true);
//     }
//   };

//   // Handle order submission from the modal
//   const handleOrderSubmit = (orderData) => {
//     console.log("Order Data:", orderData);
//     setShowOrderForm(false);

//     // 2) reset every piece of form state:
//     setBedrooms(1);
//     setBathrooms(0);
//     setKitchens(1);
//     setDrawingdinning(1);
//     setCloths(0);
//     setDishes(0);
//     setBalconies(0);
//     setWindowGrills(0);
//     setFurniture(0);
//     setStairsFloors(0);
//     setCarpets(0);
//     setRemarks("");
//     setUseSameServitor(false);
//     setFormData(null);
//   };

//   // PlusMinusInput component for numeric inputs
//   const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity, formatDisplay }) => {
//     const handleIncrement = () => {
//       if (value < max) {
//         setValue(value + 1);
//       }
//     };

//     const handleDecrement = () => {
//       if (value > min) {
//         setValue(value - 1);
//       }
//     };

//     // const displayText = `${value} ${value === 1 ? 'unit' : 'units'}`;
//     // const displayText = `${value} ${t(
//     //   value === 1 ? "homeclean.form.unit" : "homeclean.form.units"
//     // )}`;

//     const displayText = formatDisplay
//       ? formatDisplay(value)
//       : `${value} ${t(
//           value === 1 ? "homeclean.form.unit" : "homeclean.form.units"
//         )}`;

//     return (
//       <div className="HomeCleanService-unitInput">
//         <button
//           type="button"
//           className="HomeCleanService-minusBtn"
//           onClick={handleDecrement}
//           disabled={value <= min}
//         >
//           −
//         </button>
//         <span className="HomeCleanService-valueDisplay">{displayText}</span>
//         <button
//           type="button"
//           className="HomeCleanService-plusBtn"
//           onClick={handleIncrement}
//           disabled={value >= max}
//         >
//           +
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <div className="HomeCleanService-container">
//         <Navbar />
//         <Loader show={loading} />
        
//         <div className="HomeCleanService-card">
//           <div className="HomeCleanService-hero">
//             <img src={homecleanimage1} alt="Home Cleaning Services Hero" />
//           </div>

//           <div className="HomeCleanService-header">
//             <h1>
//               {/* {rebookState ? 'Rebook Home Cleaning Service' : 'Professional Home Cleaning Services'} */}
//               {t(
//                 rebookState
//                   ? "homeclean.header.rebook_title"
//                   : "homeclean.header.title"
//               )}{" "}
//               {/* CHANGED: Added translation for dynamic title */}
//             </h1>
//             {/* <div className="HomeCleanService-rating">
//             ★★★★★
//           </div>
//           <div className="HomeCleanService-reviews">
//             82,708 Verified Reviews
//           </div> */}

//             <div className="HomeCleanService-rating">
//               {renderStars(ratingData.avgRating)}
//             </div>
//             <div className="HomeCleanService-reviews">
//               {ratingData.reviewCount.toLocaleString()}{" "}
//               {t("homeclean.reviewsLabel")}
//             </div>
//           </div>

//           <div className="HomeCleanService-categories">
//             <div className="HomeCleanService-category">
//               <h5>
//                 <span className="HomeCleanService-categoryIcon">🛏️</span>
//                 {/* Bedroom Cleaning */}
//                 {t("homeclean.categories.bedroom_cleaning.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="HomeCleanService-serviceDescription">
//                 {/* Thorough cleaning of bedrooms, including dusting and vacuuming. */}
//                 {t("homeclean.categories.bedroom_cleaning.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//             <div className="HomeCleanService-category">
//               <h5>
//                 <span className="HomeCleanService-categoryIcon">🚽</span>
//                 {/* Bathroom Cleaning */}
//                 {t("homeclean.categories.bathroom_cleaning.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="HomeCleanService-serviceDescription">
//                 {/* Deep cleaning of bathrooms, sanitizing all surfaces. */}
//                 {t("homeclean.categories.bathroom_cleaning.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//             <div className="HomeCleanService-category">
//               <h5>
//                 <span className="HomeCleanService-categoryIcon">🍽️</span>
//                 {/* Kitchen Cleaning */}
//                 {t("homeclean.categories.kitchen_cleaning.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="HomeCleanService-serviceDescription">
//                 {/* Cleaning of kitchen counters, appliances, and floors. */}
//                 {t("homeclean.categories.kitchen_cleaning.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//             <div className="HomeCleanService-category">
//               <h5>
//                 <span className="HomeCleanService-categoryIcon">🧺</span>
//                 {/* Laundry Services */}
//                 {t("homeclean.categories.laundry_services.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h5>
//               <p className="HomeCleanService-serviceDescription">
//                 {/* Washing and folding of clothes and linens. */}
//                 {t("homeclean.categories.laundry_services.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>

//           <form onSubmit={handleGetService} className="HomeCleanService-form">
//             <h3 className="HomeCleanService-sectionTitle">
//               <i className="fas fa-home"></i>
//               {/* Core Room Cleaning */}
//               {t("homeclean.form.sections.core_room_cleaning.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="HomeCleanService-serviceOptions">
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="bedrooms" className="tooltip-label">
//                                   {/* Bedrooms */}
//                                   {t(
//                                     "homeclean.form.sections.core_room_cleaning.labels.bedrooms"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.bedrooms.title") || "Bedroom Cleaning"}
//                                     description={t("homeclean.tooltips.bedrooms.description") || "When you need this service:\n• Dusting furniture, shelves, and surfaces in bedrooms\n• Vacuuming floors, carpets, and under beds\n• Organizing closets and wiping windows for a fresh, tidy space"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="bedrooms"
//                   value={bedrooms}
//                   setValue={setBedrooms}
//                   // min={1} max={5}
//                 />
//               </div>
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="kitchens" className="tooltip-label">
//                                   {/* Kitchens */}
//                                   {t(
//                                     "homeclean.form.sections.core_room_cleaning.labels.kitchens"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.kitchens.title") || "Kitchen Cleaning"}
//                                     description={t("homeclean.tooltips.kitchens.description") || "When you need this service:\n• Wiping counters, cabinets, and backsplashes thoroughly\n• Cleaning appliances like stoves, microwaves, and sinks\n• Mopping floors and removing grease for a hygienic cooking area"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="kitchens"
//                   value={kitchens}
//                   setValue={setKitchens}
//                   // min={1} max={2}
//                 />
//               </div>
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="drawingdinning" className="tooltip-label">
//                                   {/* Drawing-Dining */}
//                                   {t(
//                                     "homeclean.form.sections.core_room_cleaning.labels.drawing_dining"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.drawing_dining.title") || "Drawing-Dining Cleaning"}
//                                     description={t("homeclean.tooltips.drawing_dining.description") || "When you need this service:\n• Dusting furniture, electronics, and decor in living areas\n• Vacuuming or mopping floors and rugs for spotless surfaces\n• Polishing tables and wiping windows to refresh your common spaces"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="drawingdinning"
//                   value={drawingdinning}
//                   setValue={setDrawingdinning}
//                   // min={1} max={2}
//                 />
//               </div>

//               <div className="HomeCleanService-optionGroup">
//                <label htmlFor="balconies" className="tooltip-label">
//                                  {/* Balcony Cleaning */}
//                                  {t(
//                                    "homeclean.form.sections.specialized_cleaning.labels.balconies"
//                                  )}{" "}
//                                  {/* CHANGED: Added translation */}
//                                  <ServiceTooltip
//                                    title={t("homeclean.tooltips.balconies.title") || "Balcony Cleaning"}
//                                    description={t("homeclean.tooltips.balconies.description") || "When you need this service:\n• Sweeping and mopping balcony floors to remove dirt and debris\n• Wiping railings, furniture, and planters for a clean outdoor space\n• Removing cobwebs and light dusting to enjoy fresh air comfortably"}
//                                  />
//                                </label>
//                 <PlusMinusInput
//                   id="balconies"
//                   value={balconies}
//                   setValue={setBalconies}
//                   // min={0} max={5}
//                 />
//               </div>
//             </div>

//             <h3 className="HomeCleanService-sectionTitle">
//               <i className="fas fa-spray-can"></i>
//               {/* Specialized Cleaning */}
//               {t("homeclean.form.sections.specialized_cleaning.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="HomeCleanService-serviceOptions">
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="bathroomsExtra" className="tooltip-label">
//                                   {/* Bathroom Cleaning */}
//                                   {t(
//                                     "homeclean.form.sections.specialized_cleaning.labels.bathrooms"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.bathrooms.title") || "Bathroom Cleaning"}
//                                     description={t("homeclean.tooltips.bathrooms.description") || "When you need this service:\n• Deep sanitizing of toilets, sinks, showers, and mirrors\n• Scrubbing tiles, grout, and fixtures to eliminate grime and bacteria\n• Replenishing supplies and ensuring a fresh, germ-free environment"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="bathroomsExtra"
//                   value={bathrooms}
//                   setValue={setBathrooms}
//                   // min={0} max={5}
//                 />
//               </div>
              
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="windowGrills" className="tooltip-label">
//                                   {/* Window & Grill Cleaning */}
//                                   {t(
//                                     "homeclean.form.sections.specialized_cleaning.labels.window_grills"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.window_grills.title") || "Window & Grill Cleaning"}
//                                     description={t("homeclean.tooltips.window_grills.description") || "When you need this service:\n• Wiping window panes, frames, and sills for streak-free shine\n• Cleaning grills and screens to remove dust and pollen buildup\n• Enhancing natural light and ventilation in your home"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="windowGrills"
//                   value={windowGrills}
//                   setValue={setWindowGrills}
//                   // min={0} max={10}
//                 />
//               </div>

//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="stairsFloors" className="tooltip-label">
//                                   {t(
//                                     "homeclean.form.sections.specialized_cleaning.labels.stairs_floors_label"
//                                   )}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.stairs_floors.title") || "Stairs & Floors Cleaning"}
//                                     description={t("homeclean.tooltips.stairs_floors.description") || "When you need this service:\n• Vacuuming and mopping stairs and railings for each floor\n• Removing stains and dust from steps to prevent slips\n• Deep cleaning multi-level areas for safer, cleaner navigation"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="stairsFloors"
//                   value={stairsFloors}
//                   setValue={setStairsFloors}
//                   // min={0} max={20}
//                   formatDisplay={(val) =>
//                     `${val} ${
//                       val === 1
//                         ? t("homeclean.form.floor_singular")
//                         : t("homeclean.form.floor_plural")
//                     }`
//                   }
//                 />
//               </div>
//             </div>

//             <h3 className="HomeCleanService-sectionTitle">
//               <i className="fas fa-broom"></i>
//               {/* Additional Services */}
//               {t("homeclean.form.sections.additional_services.title")}{" "}
//               {/* CHANGED: Added translation */}
//             </h3>
//             <div className="HomeCleanService-serviceOptions">
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="furniture" className="tooltip-label">
//                                   {/* Furniture Cleaning */}
//                                   {t(
//                                     "homeclean.form.sections.additional_services.labels.furniture"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.furniture.title") || "Furniture Cleaning"}
//                                     description={t("homeclean.tooltips.furniture.description") || "When you need this service:\n• Dusting and polishing sofas, tables, and chairs\n• Spot-cleaning upholstery and wood surfaces\n• Removing stains to extend the life and shine of your furniture"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="furniture"
//                   value={furniture}
//                   setValue={setFurniture}
//                   // min={0} max={5}
//                 />
//               </div>
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="cloths" className="tooltip-label">
//                                   {/* Cloth Cleaning */}
//                                   {t(
//                                     "homeclean.form.sections.additional_services.labels.cloths"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.cloths.title") || "Cloth Cleaning"}
//                                     description={t("homeclean.tooltips.cloths.description") || "When you need this service:\n• Washing and ironing clothes, linens, or curtains\n• Gentle handling for delicate fabrics to avoid damage\n• Freshening up wardrobes and storage areas for organized ease"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="cloths"
//                   value={cloths}
//                   setValue={setCloths}
//                   // min={0} max={20}
//                 />
//               </div>
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="dishes" className="tooltip-label">
//                                   {/* Dish Cleaning */}
//                                   {t(
//                                     "homeclean.form.sections.additional_services.labels.dishes"
//                                   )}{" "}
//                                   {/* CHANGED: Added translation */}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.dishes.title") || "Dish Cleaning"}
//                                     description={t("homeclean.tooltips.dishes.description") || "When you need this service:\n• Scrubbing pots, plates, and utensils for deep cleanliness\n• Sanitizing kitchenware to remove grease and residues\n• Organizing cabinets after drying for a tidy kitchen setup"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="dishes"
//                   value={dishes}
//                   setValue={setDishes}
//                   // min={0} max={10}
//                 />
//               </div>

//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="carpets" className="tooltip-label">
//                                   {t(
//                                     "homeclean.form.sections.additional_services.labels.carpets_label"
//                                   )}
//                                   <ServiceTooltip
//                                     title={t("homeclean.tooltips.carpets.title") || "Carpet Cleaning"}
//                                     description={t("homeclean.tooltips.carpets.description") || "When you need this service:\n• Vacuuming and shampooing rugs or carpets to lift dirt\n• Spot-treating stains and deodorizing for freshness\n• Reviving floor coverings to maintain hygiene and appearance"}
//                                   />
//                                 </label>
//                 <PlusMinusInput
//                   id="carpets"
//                   value={carpets}
//                   setValue={setCarpets}
//                   // min={0} max={10}
//                 />
//               </div>
//             </div>

//             {/* New added Rebook same servitor */}
//             {rebookState && prevServitorName && (
//               <div className="rebook-same-servitor">
//                 <label>
//                   <input
//                     type="checkbox"
//                     checked={useSameServitor}
//                     onChange={() => setUseSameServitor(!useSameServitor)}
//                   />
//                   {/* {t('electrician.form.rebook_same_servitor')} */}
//                   {/* {` Do you want to book ${prevServitorName} again?`} */}
//                   <span className="rebook-text">
//                     {t("homeclean.form.rebook_same_servitor_prefix")}
//                     <span className="strong-name">{prevServitorName}</span>
//                     {t("homeclean.form.rebook_same_servitor_suffix")}
//                   </span>
//                 </label>
//               </div>
//             )}

//             <div className="HomeCleanService-priceDisplay">
//               <span>
//                 {/* Estimated Price: {calculatePrice()} tk */}
//                 {t("homeclean.form.price_display", {
//                   price: calculatePrice(),
//                 })}{" "}
//                 {/* CHANGED: Added translation with interpolation */}
//               </span>
//             </div>

//             {/* Pricing note banner */}
//             <div className="HomeCleanService-priceNote" role="note" aria-live="polite">
//               <div className="HomeCleanService-priceNote-icon" aria-hidden="true">
//                 {/* small star icon (inline SVG) */}
//                 <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
//                   <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
//                 </svg>
//               </div>
//               <div className="HomeCleanService-priceNote-content">
//                 <div className="HomeCleanService-priceNote-title">
//                   {t("homeclean.price_note.title")}
//                 </div>
//                 <p className="HomeCleanService-priceNote-text">
//                   <strong>{t("homeclean.price_note.service_charges_only_label")}</strong>{" "}
//                   {t("homeclean.price_note.body")}
//                 </p>
//               </div>
//             </div>


//             <div className="HomeCleanService-bookingDetails">
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="date">
//                   {/* Preferred Date */}
//                   {t("homeclean.form.booking_details.labels.date")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </label>
//                 <div className="HomeCleanService-dateInputWrapper">
//                   <DatePicker
//                     selected={selectedDate}
//                     onChange={(date) => setSelectedDate(date)}
//                     dateFormat="dd-MMM-yyyy"
//                     minDate={new Date()}
//                     placeholderText={t(
//                       "homeclean.form.booking_details.date_placeholder"
//                     )}
//                     className="HomeCleanService-dateInput"
//                   />
//                   <FaCalendarAlt
//                     className="HomeCleanService-dateIcon"
//                     onClick={() =>
//                       document
//                         .querySelector(
//                           ".react-datepicker__input-container input"
//                         )
//                         .click()
//                     }
//                   />
//                 </div>
//               </div>
//               <div className="HomeCleanService-optionGroup">
//                 <label htmlFor="time">
//                   {/* Preferred Time */}
//                   {t("homeclean.form.booking_details.labels.time")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </label>
//                 <select id="time" name="time" required>
//                   {generateTimeSlots(selectedDate).map((slot, idx) => (
//                     <option key={idx} value={slot}>
//                       {slot}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* <h3 className="HomeCleanService-sectionTitle">
//             <i className="fas fa-comment-alt"></i>
//             {t("electrician.form.remarks_title")}{" "}
//           </h3> */}
//             <div className="HomeCleanService-serviceOptions">
//               <div className="HomeCleanService-optionGroup HomeCleanService-fullWidth">
//                 <label htmlFor="remarks">
//                   <i className="fas fa-comment-alt"></i>
//                   {t("electrician.form.labels.remarks")}
//                 </label>
//                 <textarea
//                   id="remarks"
//                   value={remarks}
//                   onChange={(e) => setRemarks(e.target.value)}
//                   placeholder={t("electrician.form.placeholders.remarks")}
//                   className="HomeCleanService-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <button type="submit" className="HomeCleanService-actionBtn">
//               {/* {rebookState ? 'Confirm Rebooking' : 'Book Service Now'} */}
//               {t(
//                 rebookState
//                   ? "homeclean.form.rebook_button"
//                   : "homeclean.form.submit_button"
//               )}{" "}
//               {/* CHANGED: Added translation for dynamic button */}
//             </button>
//           </form>

//           <div className="HomeCleanService-infoBox">
//             <h4>
//               {/* About Our Home Cleaning Services */}
//               {t("homeclean.info_box.title")} {/* CHANGED: Added translation */}
//             </h4>
//             <p>
//               {/* Our professional cleaners provide thorough cleaning services for your home, ensuring a spotless and healthy environment. All services come with a 30-day guarantee. */}
//               {t("homeclean.info_box.description")}{" "}
//               {/* CHANGED: Added translation */}
//             </p>
//           </div>

//           <div className="HomeCleanService-additionalInfo">
//             <div className="HomeCleanService-sectionCard">
//               <h2 className="HomeCleanService-sectionTitle">
//                 {/* How to Place an Order */}
//                 {t("homeclean.additional_info.how_to_place_order.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <ol className="HomeCleanService-stepList">
//                 {t("homeclean.additional_info.how_to_place_order.steps", {
//                   returnObjects: true,
//                 }).map((step, index) => (
//                   <li key={index}>
//                     {/* {step} */}
//                     {step} {/* CHANGED: Used translated steps */}
//                   </li>
//                 ))}
//               </ol>
//             </div>
//             <div className="HomeCleanService-row2col">
//               <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg2">
//                 <h2 className="HomeCleanService-sectionTitle">
//                   {/* Why Choose HelpNao for Home Cleaning */}
//                   {t("homeclean.additional_info.why_choose_HelpNao.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <p className="HomeCleanService-sectionText">
//                   {/* HelpNao connects you with top-rated home cleaning professionals who are committed to delivering exceptional service. Here’s why you should choose us: */}
//                   {t("homeclean.additional_info.why_choose_HelpNao.description")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </p>
//                 <div className="HomeCleanService-featureGrid">
//                   {t("homeclean.additional_info.why_choose_HelpNao.features", {
//                     returnObjects: true,
//                   }).map((feature, index) => (
//                     <div key={index} className="HomeCleanService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           index === 0
//                             ? "balance-scale"
//                             : index === 1
//                             ? "user-shield"
//                             : index === 2
//                             ? "mobile-alt"
//                             : "headset"
//                         } HomeCleanService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>
//                         {/* {feature} */}
//                         {feature} {/* CHANGED: Used translated features */}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg">
//                 <h2 className="HomeCleanService-sectionTitle">
//                   {/* Key Features of Our Home Cleaning Services */}
//                   {t("homeclean.additional_info.key_features.title")}{" "}
//                   {/* CHANGED: Added translation */}
//                 </h2>
//                 <div className="HomeCleanService-featureGrid">
//                   {t("homeclean.additional_info.key_features.features", {
//                     returnObjects: true,
//                   }).map((feature, index) => (
//                     <div key={index} className="HomeCleanService-featureItem">
//                       <i
//                         className={`fas fa-${
//                           index === 0
//                             ? "clock"
//                             : index === 1 || index === 3
//                             ? "shield-alt"
//                             : index === 2
//                             ? "check-circle"
//                             : "credit-card"
//                         } HomeCleanService-featureIcon`}
//                         aria-hidden="true"
//                       ></i>
//                       <p>
//                         {/* {feature} */}
//                         {feature} {/* CHANGED: Used translated features */}
//                       </p>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>
//             <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg3">
//               <h2 className="HomeCleanService-sectionTitle">
//                 {/* Order Tracking & History */}
//                 {t("homeclean.additional_info.order_tracking.title")}{" "}
//                 {/* CHANGED: Added translation */}
//               </h2>
//               <div className="HomeCleanService-orderTrackIcon">
//                 <i className="fas fa-file-alt" aria-hidden="true"></i>
//               </div>
//               <p className="HomeCleanService-sectionText HomeCleanService-centerText">
//                 {/* After booking, track your cleaning service in the “Order History” section. View upcoming appointments, service details, and payment history all in one place. */}
//                 {t("homeclean.additional_info.order_tracking.description")}{" "}
//                 {/* CHANGED: Added translation */}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Modals */}
//         {showOrderForm && (
//           <HomeCleanOrderForm
//             onClose={() => setShowOrderForm(false)}
//             onSubmit={handleOrderSubmit}
//             formData={formData}
//             user={user}
//             previousServitorName={prevServitorName}
//           />
//         )}
//         {showLoginPrompt && (
//           <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
//         )}
//       </div>

//       {/* Add Feedback Section */}
//       <div className="HomeCleanService-feedback-section">
//         <FeedbackPage serviceType="Home Cleaning" />
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default HomeClean;







// ***** Updated servicePrice,js data (25-Oct-2025) *****
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  FaCalendarAlt,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
} from "react-icons/fa";
import HomeCleanOrderForm from "./HomeCleanOrderForm";
import PromptLoginCard from "../PromptLoginCard";
import homecleanimage1 from "../images/home.png";
import "./homecleanStyle.css";
import Footer from "../../../Components/Footer/Footer";
import FeedbackPage from "../../Feedback/FeedbackPage";
import ServiceTooltip from "../../../Components/Tooltip/ServiceTooltip";
import Loader from "../../../Components/LoaderSpin/Loader";

import { HOME_CLEANING_PRICING } from "../servicePricing";

const P = HOME_CLEANING_PRICING;
const BASE_FEE = Number(P?.base ?? 0);

const HomeClean = () => {
  const { t } = useTranslation();

  const [ratingData, setRatingData] = useState({
    reviewCount: 0,
    avgRating: 0,
  });

  const location = useLocation();
  const rebookState = location.state?.fromRebook || false; //  detect rebook flag
  //  memoize previous order so useEffect deps are stable
  const prevOrder = useMemo(
    () => location.state?.previousOrder || {},
    [location.state?.previousOrder]
  );

  // State variables for form inputs and UI control
  const [useSameServitor, setUseSameServitor] = useState(false); //new added for same servitor rebook
  const [prevServitorName, setPrevServitorName] = useState(""); //new added for same servitor rebook

  const [bedrooms, setBedrooms] = useState(1);
  const [bathrooms, setBathrooms] = useState(0);
  const [kitchens, setKitchens] = useState(1);
  const [drawingdinning, setDrawingdinning] = useState(1);
  const [cloths, setCloths] = useState(0);
  const [dishes, setDishes] = useState(0);

  // new extras
  const [balconies, setBalconies] = useState(0);
  const [windowGrills, setWindowGrills] = useState(0);
  const [furniture, setFurniture] = useState(0);

  const [stairsFloors, setStairsFloors] = useState(0);
  const [carpets, setCarpets] = useState(0);

  const [remarks, setRemarks] = useState("");

  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);

  // const [selectedDate, setSelectedDate] = useState(new Date());

  const getInitialDate = () => {
    const now = new Date();
    const currentHour = now.getHours();
    // If current time is before 7:00 AM or after 9:00 PM, set date to tomorrow
    if (currentHour < 7 || currentHour >= 21) {
      const tomorrow = new Date();
      tomorrow.setDate(now.getDate() + 1);
      return tomorrow;
    }
    return now;
  };

  const [selectedDate, setSelectedDate] = useState(getInitialDate());

  useEffect(() => {
    if (rebookState) {
      setBedrooms(prevOrder.bed || 1);
      setBathrooms(prevOrder.bath || 0);
      setKitchens(prevOrder.kitchen || 1);
      setDrawingdinning(prevOrder.dra_din || 1);
      setCloths(prevOrder.cloth || 0);
      setDishes(prevOrder.dish || 0);

      // new extras:
      setBalconies(prevOrder.balcony || 0);
      setWindowGrills(prevOrder.window_grill || 0);
      setFurniture(prevOrder.furniture_cleaning || 0);

      setStairsFloors(prevOrder.stairs_and_railing || 0);
      setCarpets(prevOrder.carpet_cleaning || 0)
    }
  }, [rebookState, prevOrder]);

  // Fetch user data on component mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        if (token) {
          const decodedToken = jwtDecode(token);
          const userId = decodedToken.Id.startsWith("user-")
            ? decodedToken.Id.split("user-")[1]
            : decodedToken.Id;
          const response = await axios.get(`${URL}/user/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setUser(response.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserData();
    window.scrollTo(0, 0);
  }, []);

  //new added for same servitor rebook
  useEffect(() => {
    if (rebookState && prevOrder.servitor_id) {
      axios
        .get(`${URL}/servitors/${prevOrder.servitor_id}`)
        .then((res) => {
          const s = res.data;
          setPrevServitorName(`${s.FirstName} ${s.LastName}`);
        })
        .catch(console.error);
    }
  }, [rebookState, prevOrder.servitor_id]);

  // Fetch only electrician ratings once
  // useEffect(() => {
  //   axios
  //     .get(`${URL}/api/ratings`)
  //     .then(({ data }) => {
  //       const homeClean = data["home cleaning"];
  //       setRatingData({
  //         reviewCount: homeClean.reviewCount,
  //         avgRating: homeClean.avgRating,
  //       });
  //     })
  //     .catch((err) => console.error("Failed to load ratings:", err));
  // }, []);

  useEffect(() => {
    const loadRatings = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(`${URL}/api/ratings`);
        // handle different backend key styles
        const homeClean = data["home cleaning"] || {};
        setRatingData({
          reviewCount: homeClean.reviewCount || 0,
          avgRating: homeClean.avgRating || 0,
        });
      } catch (err) {
        console.error("Failed to load ratings:", err);
      } finally {
        setLoading(false);
      }
    };
    loadRatings();
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} />);
      } else {
        stars.push(<FaRegStar key={i} />);
      }
    }
    return stars;
  };

  // Generate available time slots based on selected date
  // const generateTimeSlots = (dateObj) => {
  //   const startTime = 7; // 7 AM
  //   const endTime = 21; // 9 PM
  //   const slots = [];
  //   const now = new Date();
  //   const todayStr = now.toISOString().split('T')[0];
  //   const selectedDateStr = dateObj.toISOString().split('T')[0];
  //   let startHour = startTime;
  //   let startMinute = 0;

  //   if (selectedDateStr === todayStr) {
  //     const currentHour = now.getHours();
  //     const currentMinute = now.getMinutes();
  //     if (currentHour >= startTime && currentHour < endTime) {
  //       if (currentMinute > 0 && currentMinute <= 30) {
  //         startHour = currentHour;
  //         startMinute = 30;
  //       } else if (currentMinute > 30) {
  //         startHour = currentHour + 1;
  //         startMinute = 0;
  //       } else {
  //         startHour = currentHour;
  //         startMinute = 0;
  //       }
  //     } else if (currentHour >= endTime) {
  //       return [];
  //     }
  //   }

  //   for (let hour = startHour; hour <= endTime; hour++) {
  //     const minuteStart = hour === startHour ? startMinute : 0;
  //     for (let minute = minuteStart; minute < 60; minute += 30) {
  //       if (selectedDateStr === todayStr) {
  //         const slotTime = new Date();
  //         slotTime.setHours(hour, minute, 0, 0);
  //         if (slotTime <= now) continue;
  //       }
  //       const displayHour = hour > 12 ? hour - 12 : hour;
  //       const ampm = hour >= 12 ? 'PM' : 'AM';
  //       const formattedTime = `${displayHour}:${String(minute).padStart(2, '0')} ${ampm}`;
  //       slots.push(formattedTime);
  //     }
  //   }
  //   return slots;
  // };

  const generateTimeSlots = (dateObj) => {
    const startTime = 7;
    const endTime = 21;
    const slots = [];
    const now = new Date();
    const todayStr = now.toISOString().split("T")[0];
    const selectedDateStr = dateObj ? dateObj.toISOString().split("T")[0] : "";

    let startHour = startTime;
    let startMinute = 0;

    // If the selected date is today, adjust slots based on current time
    if (selectedDateStr === todayStr) {
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      if (currentHour >= endTime) {
        return []; // No slots available for today
      }
      if (currentHour >= startTime) {
        // Round up to the next half-hour
        if (currentMinute > 0 && currentMinute <= 30) {
          startHour = currentHour;
          startMinute = 30;
        } else if (currentMinute > 30) {
          startHour = currentHour + 1;
          startMinute = 0;
        } else {
          startHour = currentHour;
          startMinute = 0;
        }
      }
    }

    for (let hour = startHour; hour <= endTime; hour++) {
      const minuteStart = hour === startHour ? startMinute : 0;
      for (let minute = minuteStart; minute < 60; minute += 30) {
        // Skip past slots for today
        if (selectedDateStr === todayStr) {
          const slotTime = new Date(now);
          slotTime.setHours(hour, minute, 0, 0);
          if (slotTime <= now) continue;
        }
        const displayHour = hour > 12 ? hour - 12 : hour;
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedTime = `${displayHour}:${String(minute).padStart(
          2,
          "0"
        )} ${ampm}`;
        slots.push(formattedTime);
      }
    }
    return slots;
  };

  // Calculate price based on selected options
  // const calculatePrice = () => {
  //   let price = 100; // Minimum charge
  //   price += (bedrooms - 1) * 30; // Each additional bedroom adds 30 tk
  //   price += (kitchens - 1) * 20; // Each additional kitchen adds 20 tk
  //   price += (drawingdinning - 1) * 40; // Each additional drawing-dinning adds 40 tk
  //   price += bathrooms * 50; // Each bathroom adds 50 tk

  //   // price += Math.ceil(cloths / 5) * 30; // Cloth cleaning, 30 tk per 5 pieces
  //   // price += Math.ceil(dishes / 5) * 20; // Dish cleaning, 20 tk per 5 dishes
  //   price += cloths * 10; // 10 tk per cloth
  //   price += dishes * 10; // 10 tk per dish

  //   // NEW:
  //   price += balconies * 30; // Balcony cleaning
  //   price += windowGrills * 40; // Window & grill
  //   price += furniture * 60; // Furniture

  //   price += stairsFloors * 40;    // 40 tk per floor of stairs & railing
  //   price += carpets * 50;         // 50 tk per carpet/rug

  //   return price;
  // };


  // ===== Pricing helpers from HOME_CLEANING_PRICING =====
  const U = (v) => Math.max(0, Number(v) || 0);
  const unit = (key) => Number(P?.perUnit?.[key] ?? 0);
  const firstFreeMeta = (key) => P?.firstFree?.[key] || { perAdditional: 0 };
  const fmtTk = (n) => `${(Number(n) || 0).toLocaleString()} tk`;

  // show nothing until user selects something chargeable
  const hasAnySelection = useMemo(() => {
    return (
      U(bedrooms) > 1 ||
      U(kitchens) > 1 ||
      U(drawingdinning) > 1 ||
      U(bathrooms) > 0 ||
      U(cloths) > 0 ||
      U(dishes) > 0 ||
      U(balconies) > 0 ||
      U(windowGrills) > 0 ||
      U(furniture) > 0 ||
      U(stairsFloors) > 0 ||
      U(carpets) > 0
    );
  }, [
    bedrooms,
    kitchens,
    drawingdinning,
    bathrooms,
    cloths,
    dishes,
    balconies,
    windowGrills,
    furniture,
    stairsFloors,
    carpets,
  ]);

  const calculatePrice = () => {
    let price = 0;

    // base is added only after something is selected
    if (hasAnySelection) price += BASE_FEE;

    // first-free fields
    const addFirstFree = (count, metaKey) => {
      const c = U(count);
      const perAdd = Number(firstFreeMeta(metaKey).perAdditional || 0);
      if (c > 1) price += (c - 1) * perAdd;
    };

    addFirstFree(bedrooms, "bedrooms");
    addFirstFree(kitchens, "kitchens");
    addFirstFree(drawingdinning, "drawingdinning");

    // straight per-unit fields
    price += U(bathrooms) * unit("bathrooms");
    price += U(cloths) * unit("cloths");
    price += U(dishes) * unit("dishes");
    price += U(balconies) * unit("balconies");
    price += U(windowGrills) * unit("windowGrills");
    price += U(furniture) * unit("furniture");
    price += U(stairsFloors) * unit("stairsFloors");
    price += U(carpets) * unit("carpets");

    return Math.round(price);
  };

  // Breakdown rows for UI
  const breakdownRows = useMemo(() => {
    const rows = [];

    const addFirstFreeRow = (label, count, metaKey) => {
      const c = U(count);
      const perAdd = Number(firstFreeMeta(metaKey).perAdditional || 0);
      if (c > 1) {
        rows.push({
          label,
          calc: `${c - 1} × ${fmtTk(perAdd)} =`,
          total: fmtTk((c - 1) * perAdd),
        });
      }
    };

    const addRow = (label, count, key) => {
      const c = U(count);
      if (!c) return;
      const each = unit(key);
      rows.push({
        label,
        calc: `${c} × ${fmtTk(each)} =`,
        total: fmtTk(c * each),
      });
    };

    addFirstFreeRow(
      t("homeclean.breakdown.bedrooms", "Bedrooms (additional)"),
      bedrooms,
      "bedrooms"
    );
    addFirstFreeRow(
      t("homeclean.breakdown.kitchens", "Kitchens (additional)"),
      kitchens,
      "kitchens"
    );
    addFirstFreeRow(
      t("homeclean.breakdown.drawingdinning", "Drawing & Dining (additional)"),
      drawingdinning,
      "drawingdinning"
    );

    addRow(t("homeclean.breakdown.bathrooms", "Bathrooms"), bathrooms, "bathrooms");
    addRow(t("homeclean.breakdown.cloths", "Cloths"), cloths, "cloths");
    addRow(t("homeclean.breakdown.dishes", "Dishes"), dishes, "dishes");
    addRow(t("homeclean.breakdown.balconies", "Balconies"), balconies, "balconies");
    addRow(
      t("homeclean.breakdown.windowGrills", "Window & Grills"),
      windowGrills,
      "windowGrills"
    );
    addRow(t("homeclean.breakdown.furniture", "Furniture"), furniture, "furniture");
    addRow(
      t("homeclean.breakdown.stairsFloors", "Stairs & Floors"),
      stairsFloors,
      "stairsFloors"
    );
    addRow(t("homeclean.breakdown.carpets", "Carpets/Rugs"), carpets, "carpets");

    if (rows.length > 0 && BASE_FEE > 0) {
      rows.push({
        // label: t("homeclean.breakdown.booking_fee", "Booking Fee"),
        label: t("homeclean.breakdown.platform_support_fee", "Platform & Support Fee"),
        calc: "",
        total: fmtTk(BASE_FEE),
      });
    }

    return rows;
  }, [
    t,
    bedrooms,
    kitchens,
    drawingdinning,
    bathrooms,
    cloths,
    dishes,
    balconies,
    windowGrills,
    furniture,
    stairsFloors,
    carpets,
  ]);


  // Handle form submission
  const handleGetService = (e) => {
    e.preventDefault();
    const time = e.target.time.value;
    const dateStr = selectedDate.toISOString().split("T")[0];
    const formDetails = {
      bedrooms,
      bathrooms,
      kitchens,
      drawingdinning,
      cloths,
      dishes,
      balconies,
      windowGrills,
      furniture,

      stairsFloors,
      carpets,

      remarks,

      price: calculatePrice(),
      date: dateStr,
      time,

      // new added for rebook same servitor
      useSameServitor,
      servitor_id: useSameServitor ? prevOrder.servitor_id : undefined,
    };
    setFormData(formDetails);
    if (user) {
      setShowOrderForm(true);
    } else {
      setShowLoginPrompt(true);
    }
  };

  // Handle order submission from the modal
  const handleOrderSubmit = (orderData) => {
    // console.log("Order Data:", orderData);
    setShowOrderForm(false);

    // 2) reset every piece of form state:
    setBedrooms(1);
    setBathrooms(0);
    setKitchens(1);
    setDrawingdinning(1);
    setCloths(0);
    setDishes(0);
    setBalconies(0);
    setWindowGrills(0);
    setFurniture(0);
    setStairsFloors(0);
    setCarpets(0);
    setRemarks("");
    setUseSameServitor(false);
    setFormData(null);
  };

  // PlusMinusInput component for numeric inputs
  const PlusMinusInput = ({ id, value, setValue, min = 0, max = Infinity, formatDisplay }) => {
    const handleIncrement = () => {
      if (value < max) setValue(value + 1);
    };
    const handleDecrement = () => {
      if (value > min) setValue(value - 1);
    };
    const displayText = formatDisplay
      ? formatDisplay(value)
      : `${value} ${t(value === 1 ? "homeclean.form.unit" : "homeclean.form.units")}`;

    return (
      <div className="HomeCleanService-unitInput">
        <button
          type="button"
          className="HomeCleanService-minusBtn"
          onClick={handleDecrement}
          disabled={value <= min}
        >
          −
        </button>
        <span className="HomeCleanService-valueDisplay">{displayText}</span>
        <button
          type="button"
          className="HomeCleanService-plusBtn"
          onClick={handleIncrement}
          disabled={value >= max}
        >
          +
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="HomeCleanService-container">
        <Navbar />
        <Loader show={loading} />

        <div className="HomeCleanService-card">
          <div className="HomeCleanService-hero">
            <img src={homecleanimage1} alt="Home Cleaning Services Hero" />
          </div>

          <div className="HomeCleanService-header">
            <h1>
              {/* {rebookState ? 'Rebook Home Cleaning Service' : 'Professional Home Cleaning Services'} */}
              {t(
                rebookState
                  ? "homeclean.header.rebook_title"
                  : "homeclean.header.title"
              )}{" "}
              {/* CHANGED: Added translation for dynamic title */}
            </h1>
            {/* <div className="HomeCleanService-rating">
            ★★★★★
          </div>
          <div className="HomeCleanService-reviews">
            82,708 Verified Reviews
          </div> */}

            <div className="HomeCleanService-rating">
              {renderStars(ratingData.avgRating)}
            </div>
            <div className="HomeCleanService-reviews">
              {ratingData.reviewCount.toLocaleString()}{" "}
              {t("homeclean.reviewsLabel")}
            </div>
          </div>

          

          <form onSubmit={handleGetService} className="HomeCleanService-form">
            <h3 className="HomeCleanService-sectionTitle">
              <i className="fas fa-home"></i>
              {/* Core Room Cleaning */}
              {t("homeclean.form.sections.core_room_cleaning.title")}{" "}
              {/* CHANGED: Added translation */}
            </h3>
            <div className="HomeCleanService-serviceOptions">
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="bedrooms" className="tooltip-label">
                  {/* Bedrooms */}
                  {t(
                    "homeclean.form.sections.core_room_cleaning.labels.bedrooms"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.bedrooms.title") || "Bedroom Cleaning"}
                    description={t("homeclean.tooltips.bedrooms.description") || "When you need this service:\n• Dusting furniture, shelves, and surfaces in bedrooms\n• Vacuuming floors, carpets, and under beds\n• Organizing closets and wiping windows for a fresh, tidy space"}
                  />
                </label>
                <PlusMinusInput
                  id="bedrooms"
                  value={bedrooms}
                  setValue={setBedrooms}
                // min={1} max={5}
                />
              </div>
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="kitchens" className="tooltip-label">
                  {/* Kitchens */}
                  {t(
                    "homeclean.form.sections.core_room_cleaning.labels.kitchens"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.kitchens.title") || "Kitchen Cleaning"}
                    description={t("homeclean.tooltips.kitchens.description") || "When you need this service:\n• Wiping counters, cabinets, and backsplashes thoroughly\n• Cleaning appliances like stoves, microwaves, and sinks\n• Mopping floors and removing grease for a hygienic cooking area"}
                  />
                </label>
                <PlusMinusInput
                  id="kitchens"
                  value={kitchens}
                  setValue={setKitchens}
                // min={1} max={2}
                />
              </div>
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="drawingdinning" className="tooltip-label">
                  {/* Drawing-Dining */}
                  {t(
                    "homeclean.form.sections.core_room_cleaning.labels.drawing_dining"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.drawing_dining.title") || "Drawing-Dining Cleaning"}
                    description={t("homeclean.tooltips.drawing_dining.description") || "When you need this service:\n• Dusting furniture, electronics, and decor in living areas\n• Vacuuming or mopping floors and rugs for spotless surfaces\n• Polishing tables and wiping windows to refresh your common spaces"}
                  />
                </label>
                <PlusMinusInput
                  id="drawingdinning"
                  value={drawingdinning}
                  setValue={setDrawingdinning}
                // min={1} max={2}
                />
              </div>

              <div className="HomeCleanService-optionGroup">
                <label htmlFor="balconies" className="tooltip-label">
                  {/* Balcony Cleaning */}
                  {t(
                    "homeclean.form.sections.specialized_cleaning.labels.balconies"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.balconies.title") || "Balcony Cleaning"}
                    description={t("homeclean.tooltips.balconies.description") || "When you need this service:\n• Sweeping and mopping balcony floors to remove dirt and debris\n• Wiping railings, furniture, and planters for a clean outdoor space\n• Removing cobwebs and light dusting to enjoy fresh air comfortably"}
                  />
                </label>
                <PlusMinusInput
                  id="balconies"
                  value={balconies}
                  setValue={setBalconies}
                // min={0} max={5}
                />
              </div>
            </div>

            <h3 className="HomeCleanService-sectionTitle">
              <i className="fas fa-spray-can"></i>
              {/* Specialized Cleaning */}
              {t("homeclean.form.sections.specialized_cleaning.title")}{" "}
              {/* CHANGED: Added translation */}
            </h3>
            <div className="HomeCleanService-serviceOptions">
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="bathroomsExtra" className="tooltip-label">
                  {/* Bathroom Cleaning */}
                  {t(
                    "homeclean.form.sections.specialized_cleaning.labels.bathrooms"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.bathrooms.title") || "Bathroom Cleaning"}
                    description={t("homeclean.tooltips.bathrooms.description") || "When you need this service:\n• Deep sanitizing of toilets, sinks, showers, and mirrors\n• Scrubbing tiles, grout, and fixtures to eliminate grime and bacteria\n• Replenishing supplies and ensuring a fresh, germ-free environment"}
                  />
                </label>
                <PlusMinusInput
                  id="bathroomsExtra"
                  value={bathrooms}
                  setValue={setBathrooms}
                // min={0} max={5}
                />
              </div>

              <div className="HomeCleanService-optionGroup">
                <label htmlFor="windowGrills" className="tooltip-label">
                  {/* Window & Grill Cleaning */}
                  {t(
                    "homeclean.form.sections.specialized_cleaning.labels.window_grills"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.window_grills.title") || "Window & Grill Cleaning"}
                    description={t("homeclean.tooltips.window_grills.description") || "When you need this service:\n• Wiping window panes, frames, and sills for streak-free shine\n• Cleaning grills and screens to remove dust and pollen buildup\n• Enhancing natural light and ventilation in your home"}
                  />
                </label>
                <PlusMinusInput
                  id="windowGrills"
                  value={windowGrills}
                  setValue={setWindowGrills}
                // min={0} max={10}
                />
              </div>

              <div className="HomeCleanService-optionGroup">
                <label htmlFor="stairsFloors" className="tooltip-label">
                  {t(
                    "homeclean.form.sections.specialized_cleaning.labels.stairs_floors_label"
                  )}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.stairs_floors.title") || "Stairs & Floors Cleaning"}
                    description={t("homeclean.tooltips.stairs_floors.description") || "When you need this service:\n• Vacuuming and mopping stairs and railings for each floor\n• Removing stains and dust from steps to prevent slips\n• Deep cleaning multi-level areas for safer, cleaner navigation"}
                  />
                </label>
                <PlusMinusInput
                  id="stairsFloors"
                  value={stairsFloors}
                  setValue={setStairsFloors}
                  // min={0} max={20}
                  formatDisplay={(val) =>
                    `${val} ${val === 1
                      ? t("homeclean.form.floor_singular")
                      : t("homeclean.form.floor_plural")
                    }`
                  }
                />
              </div>
            </div>

            <h3 className="HomeCleanService-sectionTitle">
              <i className="fas fa-broom"></i>
              {/* Additional Services */}
              {t("homeclean.form.sections.additional_services.title")}{" "}
              {/* CHANGED: Added translation */}
            </h3>
            <div className="HomeCleanService-serviceOptions">
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="furniture" className="tooltip-label">
                  {/* Furniture Cleaning */}
                  {t(
                    "homeclean.form.sections.additional_services.labels.furniture"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.furniture.title") || "Furniture Cleaning"}
                    description={t("homeclean.tooltips.furniture.description") || "When you need this service:\n• Dusting and polishing sofas, tables, and chairs\n• Spot-cleaning upholstery and wood surfaces\n• Removing stains to extend the life and shine of your furniture"}
                  />
                </label>
                <PlusMinusInput
                  id="furniture"
                  value={furniture}
                  setValue={setFurniture}
                // min={0} max={5}
                />
              </div>
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="cloths" className="tooltip-label">
                  {/* Cloth Cleaning */}
                  {t(
                    "homeclean.form.sections.additional_services.labels.cloths"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.cloths.title") || "Cloth Cleaning"}
                    description={t("homeclean.tooltips.cloths.description") || "When you need this service:\n• Washing and ironing clothes, linens, or curtains\n• Gentle handling for delicate fabrics to avoid damage\n• Freshening up wardrobes and storage areas for organized ease"}
                  />
                </label>
                <PlusMinusInput
                  id="cloths"
                  value={cloths}
                  setValue={setCloths}
                // min={0} max={20}
                />
              </div>
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="dishes" className="tooltip-label">
                  {/* Dish Cleaning */}
                  {t(
                    "homeclean.form.sections.additional_services.labels.dishes"
                  )}{" "}
                  {/* CHANGED: Added translation */}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.dishes.title") || "Dish Cleaning"}
                    description={t("homeclean.tooltips.dishes.description") || "When you need this service:\n• Scrubbing pots, plates, and utensils for deep cleanliness\n• Sanitizing kitchenware to remove grease and residues\n• Organizing cabinets after drying for a tidy kitchen setup"}
                  />
                </label>
                <PlusMinusInput
                  id="dishes"
                  value={dishes}
                  setValue={setDishes}
                // min={0} max={10}
                />
              </div>

              <div className="HomeCleanService-optionGroup">
                <label htmlFor="carpets" className="tooltip-label">
                  {t(
                    "homeclean.form.sections.additional_services.labels.carpets_label"
                  )}
                  <ServiceTooltip
                    title={t("homeclean.tooltips.carpets.title") || "Carpet Cleaning"}
                    description={t("homeclean.tooltips.carpets.description") || "When you need this service:\n• Vacuuming and shampooing rugs or carpets to lift dirt\n• Spot-treating stains and deodorizing for freshness\n• Reviving floor coverings to maintain hygiene and appearance"}
                  />
                </label>
                <PlusMinusInput
                  id="carpets"
                  value={carpets}
                  setValue={setCarpets}
                // min={0} max={10}
                />
              </div>
            </div>

            {/* New added Rebook same servitor */}
            {rebookState && prevServitorName && (
              <div className="rebook-same-servitor">
                <label>
                  <input
                    type="checkbox"
                    checked={useSameServitor}
                    onChange={() => setUseSameServitor(!useSameServitor)}
                  />
                  {/* {t('electrician.form.rebook_same_servitor')} */}
                  {/* {` Do you want to book ${prevServitorName} again?`} */}
                  <span className="rebook-text">
                    {t("homeclean.form.rebook_same_servitor_prefix")}
                    <span className="strong-name">{prevServitorName}</span>
                    {t("homeclean.form.rebook_same_servitor_suffix")}
                  </span>
                </label>
              </div>
            )}


            {/* ---------- Price Breakdown (only when selection made) ---------- */}
            {breakdownRows.length > 0 && (
              <div className="HomeCleanService-breakdownCard" aria-live="polite">
                <div className="HomeCleanService-breakdownHeader">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 4v4h10V6H7zm0 6v6h10v-6H7zm2 1h2v2H9v-2zm0 3h2v2H9v-2zm4-3h2v2h-2v-2zm0 3h2v2h-2v-2z" />
                  </svg>
                  <span>{t("homeclean.breakdown.title", "Price Breakdown")}</span>
                </div>
                <ul className="HomeCleanService-breakdownList">
                  {breakdownRows.map((row, idx) => (
                    <li key={idx} className="HomeCleanService-breakdownRow">
                      <span className="HomeCleanService-breakdownLabel">{row.label}</span>
                      <span className="HomeCleanService-breakdownRight">
                        {row.calc && <span className="HomeCleanService-breakdownCalc">{row.calc}</span>}
                        <span className="HomeCleanService-breakdownTotal">{row.total}</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}


            <div className="HomeCleanService-priceDisplay">
              <span>
                {/* Estimated Price: {calculatePrice()} tk */}
                {t("homeclean.form.price_display", {
                  price: calculatePrice(),
                })}{" "}
                {/* CHANGED: Added translation with interpolation */}
              </span>
            </div>

            {/* Pricing note banner */}
            <div className="HomeCleanService-priceNote" role="note" aria-live="polite">
              <div className="HomeCleanService-priceNote-icon" aria-hidden="true">
                {/* small star icon (inline SVG) */}
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <div className="HomeCleanService-priceNote-content">
                <div className="HomeCleanService-priceNote-title">
                  {t("homeclean.price_note.title")}
                </div>
                <p className="HomeCleanService-priceNote-text">
                  <strong>{t("homeclean.price_note.service_charges_only_label")}</strong>{" "}
                  {t("homeclean.price_note.body")}
                </p>
              </div>
            </div>


            <div className="HomeCleanService-bookingDetails">
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="date">
                  {/* Preferred Date */}
                  {t("homeclean.form.booking_details.labels.date")}{" "}
                  {/* CHANGED: Added translation */}
                </label>
                <div className="HomeCleanService-dateInputWrapper">
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MMM-yyyy"
                    minDate={new Date()}
                    placeholderText={t(
                      "homeclean.form.booking_details.date_placeholder"
                    )}
                    className="HomeCleanService-dateInput"
                  />
                  <FaCalendarAlt
                    className="HomeCleanService-dateIcon"
                    onClick={() =>
                      document
                        .querySelector(
                          ".react-datepicker__input-container input"
                        )
                        .click()
                    }
                  />
                </div>
              </div>
              <div className="HomeCleanService-optionGroup">
                <label htmlFor="time">
                  {/* Preferred Time */}
                  {t("homeclean.form.booking_details.labels.time")}{" "}
                  {/* CHANGED: Added translation */}
                </label>
                <select id="time" name="time" required>
                  {generateTimeSlots(selectedDate).map((slot, idx) => (
                    <option key={idx} value={slot}>
                      {slot}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* <h3 className="HomeCleanService-sectionTitle">
            <i className="fas fa-comment-alt"></i>
            {t("electrician.form.remarks_title")}{" "}
          </h3> */}
            <div className="HomeCleanService-serviceOptions">
              <div className="HomeCleanService-optionGroup HomeCleanService-fullWidth">
                <label htmlFor="remarks">
                  <i className="fas fa-comment-alt"></i>
                  {t("electrician.form.labels.remarks")}
                </label>
                <textarea
                  id="remarks"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  placeholder={t("electrician.form.placeholders.remarks")}
                  className="HomeCleanService-textarea"
                  rows="2"
                />
              </div>
            </div>

            <button type="submit" className="HomeCleanService-actionBtn">
              {/* {rebookState ? 'Confirm Rebooking' : 'Book Service Now'} */}
              {t(
                rebookState
                  ? "homeclean.form.rebook_button"
                  : "homeclean.form.submit_button"
              )}{" "}
              {/* CHANGED: Added translation for dynamic button */}
            </button>
          </form>

          <div className="HomeCleanService-infoBox">
            <h4>
              {/* About Our Home Cleaning Services */}
              {t("homeclean.info_box.title")} {/* CHANGED: Added translation */}
            </h4>
            <p>
              {/* Our professional cleaners provide thorough cleaning services for your home, ensuring a spotless and healthy environment. All services come with a 30-day guarantee. */}
              {t("homeclean.info_box.description")}{" "}
              {/* CHANGED: Added translation */}
            </p>
          </div>

          <div className="HomeCleanService-additionalInfo">
            <div className="HomeCleanService-sectionCard">
              <h2 className="HomeCleanService-sectionTitle">
                {/* How to Place an Order */}
                {t("homeclean.additional_info.how_to_place_order.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <ol className="HomeCleanService-stepList">
                {t("homeclean.additional_info.how_to_place_order.steps", {
                  returnObjects: true,
                }).map((step, index) => (
                  <li key={index}>
                    {/* {step} */}
                    {step} {/* CHANGED: Used translated steps */}
                  </li>
                ))}
              </ol>
            </div>
            <div className="HomeCleanService-row2col">
              <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg2">
                <h2 className="HomeCleanService-sectionTitle">
                  {/* Why Choose HelpNao for Home Cleaning */}
                  {t("homeclean.additional_info.why_choose_HelpNao.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <p className="HomeCleanService-sectionText">
                  {/* HelpNao connects you with top-rated home cleaning professionals who are committed to delivering exceptional service. Here’s why you should choose us: */}
                  {t("homeclean.additional_info.why_choose_HelpNao.description")}{" "}
                  {/* CHANGED: Added translation */}
                </p>
                <div className="HomeCleanService-featureGrid">
                  {t("homeclean.additional_info.why_choose_HelpNao.features", {
                    returnObjects: true,
                  }).map((feature, index) => (
                    <div key={index} className="HomeCleanService-featureItem">
                      <i
                        className={`fas fa-${index === 0
                            ? "balance-scale"
                            : index === 1
                              ? "user-shield"
                              : index === 2
                                ? "mobile-alt"
                                : "headset"
                          } HomeCleanService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>
                        {/* {feature} */}
                        {feature} {/* CHANGED: Used translated features */}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
              <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg">
                <h2 className="HomeCleanService-sectionTitle">
                  {/* Key Features of Our Home Cleaning Services */}
                  {t("homeclean.additional_info.key_features.title")}{" "}
                  {/* CHANGED: Added translation */}
                </h2>
                <div className="HomeCleanService-featureGrid">
                  {t("homeclean.additional_info.key_features.features", {
                    returnObjects: true,
                  }).map((feature, index) => (
                    <div key={index} className="HomeCleanService-featureItem">
                      <i
                        className={`fas fa-${index === 0
                            ? "clock"
                            : index === 1 || index === 3
                              ? "shield-alt"
                              : index === 2
                                ? "check-circle"
                                : "credit-card"
                          } HomeCleanService-featureIcon`}
                        aria-hidden="true"
                      ></i>
                      <p>
                        {/* {feature} */}
                        {feature} {/* CHANGED: Used translated features */}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="HomeCleanService-sectionCard HomeCleanService-gradientBg3">
              <h2 className="HomeCleanService-sectionTitle">
                {/* Order Tracking & History */}
                {t("homeclean.additional_info.order_tracking.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <div className="HomeCleanService-orderTrackIcon">
                <i className="fas fa-file-alt" aria-hidden="true"></i>
              </div>
              <p className="HomeCleanService-sectionText HomeCleanService-centerText">
                {/* After booking, track your cleaning service in the “Order History” section. View upcoming appointments, service details, and payment history all in one place. */}
                {t("homeclean.additional_info.order_tracking.description")}{" "}
                {/* CHANGED: Added translation */}
              </p>
            </div>
          </div>
        </div>

        {/* Modals */}
        {showOrderForm && (
          <HomeCleanOrderForm
            onClose={() => setShowOrderForm(false)}
            onSubmit={handleOrderSubmit}
            formData={formData}
            user={user}
            previousServitorName={prevServitorName}
          />
        )}
        {showLoginPrompt && (
          <PromptLoginCard onClose={() => setShowLoginPrompt(false)} />
        )}
      </div>

      {/* Add Feedback Section */}
      <div className="HomeCleanService-feedback-section">
        <FeedbackPage serviceType="Home Cleaning" />
      </div>

      <Footer />
    </>
  );
};

export default HomeClean;
